var map = {
	"./_template.jsx": 387,
	"./docs/ConvertLib.json": 1080,
	"./docs/MetaCoin.json": 1081,
	"./docs/Migrations.json": 1082,
	"./docs/_template.jsx": 1083,
	"./index.md": 1084
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1079;



//////////////////
// WEBPACK FOOTER
// . (coffee|cjsx|jsx|js|markdown|md|ipynb|html|json|yaml|toml)$
// module id = 1079
// module chunks = 0